// import React, { useEffect, useMemo, useState } from "react";
// import { useNavigate } from "react-router-dom";

// import { createEmployeePublic } from "../../lib/employeesApi";
// import {
//   ensureSignedIn, // anonymous auth for storage/upload rules
//   signUpWithEmailPassword,
//   signInWithGoogle,
//   getCurrentUser,
// } from "../../lib/authSession";

// import {
//   subscribeCategories,
//   subscribeSubcategories,
//   subscribeServiceItems,
// } from "../../lib/servicesApi";

// import DocumentScanModal from "../../Components/DocumentScanModal";
// import { uploadToStorage } from "../../utils/storage";

// // Location datasets
// import locationNation from "../../data/locationNation.json"; // states & districts
// import locationData from "../../data/locationData.json"; // districts -> mandals

// const AUTHORIZED_ID_TYPES = [
//   "Aadhaar",
//   "PAN",
//   "VoterID",
//   "Driving License",
//   "Passport",
//   "EShram",
//   "Ration Card",
//   "Employee ID",
//   "Other",
// ];

// // ---- helpers to read mandals irrespective of exact JSON shape ----
// function buildMandalsIndex(raw) {
//   const byDistrict = new Map();

//   // Shape A: { districts: [ { district, mandals } ] }
//   if (raw?.districts && Array.isArray(raw.districts)) {
//     raw.districts.forEach((d) => {
//       const name = (d?.district || "").trim();
//       const list = Array.isArray(d?.mandals) ? d.mandals : [];
//       if (name) byDistrict.set(name, list);
//     });
//     return byDistrict;
//   }

//   // Shape B: { states: [ { state, districts: [ { district, mandals } ] } ] }
//   if (raw?.states && Array.isArray(raw.states)) {
//     raw.states.forEach((s) => {
//       (s?.districts || []).forEach((d) => {
//         const name = (d?.district || "").trim();
//         const list = Array.isArray(d?.mandals) ? d.mandals : [];
//         if (name) byDistrict.set(name, list);
//       });
//     });
//     return byDistrict;
//   }

//   // Fallback (empty)
//   return byDistrict;
// }

// const mandalsByDistrict = buildMandalsIndex(locationData);
// const ADD_MANDAL_SENTINEL = "__ADD_MANDA__";

// export default function EmployeesPublicRegister() {
//   const navigate = useNavigate();

//   // ---------- Auth ----------
//   const [authStep, setAuthStep] = useState("choose"); // "choose" | "email" | "done"
//   const [authBusy, setAuthBusy] = useState(false);
//   const [authError, setAuthError] = useState(null);
//   const [authEmail, setAuthEmail] = useState("");
//   const [authPassword, setAuthPassword] = useState("");

//   useEffect(() => {
//     const u = getCurrentUser?.();
//     if (u) {
//       setForm((f) => ({
//         ...f,
//         email: u.email || f.email,
//         firstName: u.displayName?.split(" ")?.[0] || f.firstName,
//         lastName: u.displayName?.split(" ")?.slice(1).join(" ") || f.lastName,
//       }));
//       setAuthStep("done");
//     }
//   }, []);

//   const handleEmailSignup = async (e) => {
//     e.preventDefault();
//     setAuthError(null);
//     if (!authEmail || !authPassword) {
//       setAuthError(new Error("Email and Password are required."));
//       return;
//     }
//     try {
//       setAuthBusy(true);
//       const user = await signUpWithEmailPassword(
//         authEmail.trim(),
//         authPassword
//       );
//       setForm((f) => ({
//         ...f,
//         email: user.email || authEmail.trim(),
//         firstName: user.displayName?.split(" ")?.[0] || f.firstName,
//         lastName:
//           user.displayName?.split(" ")?.slice(1).join(" ") || f.lastName,
//       }));
//       setAuthStep("done");
//     } catch (err) {
//       console.error("Email signup failed:", err);
//       setAuthError(err);
//     } finally {
//       setAuthBusy(false);
//     }
//   };

//   const handleGoogleSignup = async () => {
//     setAuthError(null);
//     try {
//       setAuthBusy(true);
//       const user = await signInWithGoogle();
//       if (user?.uid) {
//         setForm((f) => ({
//           ...f,
//           email: user.email || f.email,
//           firstName: user.displayName?.split(" ")?.[0] || f.firstName,
//           lastName:
//             user.displayName?.split(" ")?.slice(1).join(" ") || f.lastName,
//         }));
//         setAuthStep("done");
//       }
//     } catch (err) {
//       console.error("Google sign-in failed:", err);
//       setAuthError(err);
//     } finally {
//       setAuthBusy(false);
//     }
//   };

//   // ---------- Upload modal ----------
//   const [scanModal, setScanModal] = useState({
//     show: false,
//     title: "",
//     target: null, // 'id' | 'pp'
//     idIndex: null,
//     file: null,
//     options: {},
//   });

//   // ---------- Form ----------
//   const [busy, setBusy] = useState(false);
//   const [error, setError] = useState(null);

//   const [form, setForm] = useState({
//     firstName: "",
//     lastName: "",
//     fatherName: "",
//     mobile: "",
//     email: "",

//     // Address
//     address: "",
//     state: "",
//     district: "",
//     mandal: "",

//     aadhaar: "",
//     pan: "",

//     // IDs: min 2
//     ids: [
//       { type: "", value: "", imageUrl: "" },
//       { type: "", value: "", imageUrl: "" },
//     ],

//     // Optional profile
//     profilePhotoUrl: "",

//     // Job preferences (now Category → Subcategory → Title)
//     jobs: [
//       { title: "", categoryKey: "", subcategoryKey: "", experienceYears: "" },
//     ],

//     availability: "full-time",
//     bio: "",
//   });

//   // ---------- Location selectors ----------
//   const statesList = useMemo(
//     () => (locationNation?.states || []).map((s) => s.state),
//     []
//   );
//   const districtsByState = useMemo(() => {
//     const map = new Map();
//     (locationNation?.states || []).forEach((s) => {
//       map.set(s.state, s.districts || []);
//     });
//     return map;
//   }, []);

//   // Custom mandals added by the user per district (in-memory)
//   const [customMandals, setCustomMandals] = useState(new Map());
//   const [mandalAddMode, setMandalAddMode] = useState(false);
//   const [mandalInput, setMandalInput] = useState("");

//   const districtsForSelected = useMemo(
//     () => districtsByState.get(form.state) || [],
//     [districtsByState, form.state]
//   );

//   const mandalsForSelected = useMemo(() => {
//     const base = mandalsByDistrict.get(form.district) || [];
//     const extra = customMandals.get(form.district) || [];
//     // unique merge
//     return Array.from(new Set([...base, ...extra]));
//   }, [form.district, customMandals]);

//   const addCustomMandal = () => {
//     const m = (mandalInput || "").trim();
//     if (!m) return;
//     const next = new Map(customMandals);
//     const arr = next.get(form.district) || [];
//     if (!arr.includes(m)) arr.push(m);
//     next.set(form.district, arr);
//     setCustomMandals(next);
//     setForm((f) => ({ ...f, mandal: m }));
//     setMandalAddMode(false);
//     setMandalInput("");
//   };

//   // reset when state/district changes
//   useEffect(() => {
//     setForm((f) => ({ ...f, district: "", mandal: "" }));
//     setMandalAddMode(false);
//     setMandalInput("");
//   }, [form.state]);
//   useEffect(() => {
//     setForm((f) => ({ ...f, mandal: "" }));
//     setMandalAddMode(false);
//     setMandalInput("");
//   }, [form.district]);

//   // ---------- Services (Categories/Subcategories/Job Titles) ----------
//   const [cats, setCats] = useState([]);
//   const [subcats, setSubcats] = useState([]);
//   const [services, setServices] = useState([]);
//   const [catError, setCatError] = useState(null);
//   const [subcatError, setSubcatError] = useState(null);
//   const [servicesError, setServicesError] = useState(null);

//   useEffect(() => subscribeCategories(setCats, setCatError), []);
//   useEffect(() => subscribeSubcategories(setSubcats, setSubcatError), []);
//   useEffect(
//     () => subscribeServiceItems?.(setServices, setServicesError, {}),
//     []
//   );

//   const activeCats = useMemo(
//     () => (cats || []).filter((c) => c.active),
//     [cats]
//   );

//   const subcatsByCat = useMemo(() => {
//     const map = new Map();
//     (subcats || []).forEach((s) => {
//       const arr = map.get(s.categoryKey) || [];
//       arr.push(s);
//       map.set(s.categoryKey, arr);
//     });
//     for (const [k, v] of map) {
//       v.sort((a, b) => (a.label || "").localeCompare(b.label || ""));
//       map.set(k, v);
//     }
//     return map;
//   }, [subcats]);

//   const jobTitlesByCatSub = useMemo(() => {
//     const map = new Map();
//     (services || [])
//       .filter((s) => s?.isActive !== false)
//       .forEach((s) => {
//         const catKey = s.category || "";
//         const subKey = s.subcategory || "";
//         const key = `${catKey}|${subKey}`;
//         const list = map.get(key) || [];
//         list.push({ value: s.slug || s.name, label: s.name || s.slug || "-" });
//         map.set(key, list);
//       });
//     for (const [k, v] of map) {
//       v.sort((a, b) => (a.label || "").localeCompare(b.label || ""));
//       map.set(k, v);
//     }
//     return map;
//   }, [services]);

//   // defaults for first job row when services load
//   useEffect(() => {
//     const firstCatKey = activeCats[0]?.key;
//     if (!firstCatKey) return;
//     setForm((f) => {
//       if (f.jobs[0]?.categoryKey) return f;
//       const jobs = [...f.jobs];
//       const subs = subcatsByCat.get(firstCatKey) || [];
//       const firstSubKey = subs[0]?.key || "";
//       const titles =
//         jobTitlesByCatSub.get(`${firstCatKey}|${firstSubKey}`) || [];
//       const firstTitle = titles[0]?.label || "";
//       jobs[0] = {
//         ...jobs[0],
//         categoryKey: firstCatKey,
//         subcategoryKey: firstSubKey,
//         title: firstTitle,
//       };
//       return { ...f, jobs };
//     });
//   }, [activeCats, subcatsByCat, jobTitlesByCatSub]);

//   const handleJobChange = (index, key, value) => {
//     setForm((f) => {
//       const jobs = [...f.jobs];
//       jobs[index] = { ...jobs[index], [key]: value };
//       return { ...f, jobs };
//     });
//   };
//   const onJobCategoryChange = (index, categoryKey) => {
//     const subs = subcatsByCat.get(categoryKey) || [];
//     const newSubKey = subs[0]?.key || "";
//     setForm((f) => {
//       const jobs = [...f.jobs];
//       jobs[index] = { ...jobs[index], categoryKey, subcategoryKey: newSubKey };
//       return { ...f, jobs };
//     });
//     const titles = jobTitlesByCatSub.get(`${categoryKey}|${newSubKey}`) || [];
//     const firstTitle = titles[0]?.label || "";
//     setForm((f) => {
//       const jobs = [...f.jobs];
//       jobs[index] = { ...jobs[index], title: firstTitle };
//       return { ...f, jobs };
//     });
//   };
//   const onJobSubcategoryChange = (index, subcategoryKey) => {
//     setForm((f) => {
//       const jobs = [...f.jobs];
//       jobs[index] = { ...jobs[index], subcategoryKey };
//       return { ...f, jobs };
//     });
//     const categoryKey = form.jobs[index]?.categoryKey || "";
//     const titles =
//       jobTitlesByCatSub.get(`${categoryKey}|${subcategoryKey}`) || [];
//     const firstTitle = titles[0]?.label || "";
//     setForm((f) => {
//       const jobs = [...f.jobs];
//       jobs[index] = { ...jobs[index], title: firstTitle };
//       return { ...f, jobs };
//     });
//   };

//   // ---------- Handlers ----------
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((f) => ({ ...f, [name]: value }));
//   };

//   const handleIdChange = (index, key, value) => {
//     setForm((f) => {
//       const ids = [...f.ids];
//       const v = typeof value === "string" ? value.trim() : value;
//       ids[index] = { ...ids[index], [key]: v };
//       return { ...f, ids };
//     });
//   };

//   const addIdRow = () =>
//     setForm((f) => ({
//       ...f,
//       ids: [...f.ids, { type: "", value: "", imageUrl: "" }],
//     }));

//   const removeIdRow = (index) =>
//     setForm((f) => ({ ...f, ids: f.ids.filter((_, i) => i !== index) }));

//   const onSubmit = async (e) => {
//     e.preventDefault();
//     setError(null);

//     if (!form.firstName || !form.mobile) {
//       setError(new Error("Please fill First Name and Mobile."));
//       return;
//     }
//     if (!form.state || !form.district) {
//       setError(new Error("Please select State and District."));
//       return;
//     }

//     const normalizeId = (r = {}) => ({
//       type: String(r.type || "").trim(),
//       value: String(r.value || "").trim(),
//       imageUrl: String(r.imageUrl || "").trim(),
//     });
//     const completeIds = (form.ids || [])
//       .map(normalizeId)
//       .filter((r) => r.type && r.value && r.imageUrl);
//     if (completeIds.length < 2) {
//       setError(
//         new Error("Please attach at least two Authorized IDs with photos.")
//       );
//       return;
//     }

//     // Normalize jobs: keep any row that has something
//     const jobs = (form.jobs || [])
//       .map((j) => ({
//         title: String(j.title || "").trim(),
//         categoryKey: j.categoryKey || null,
//         subcategoryKey: j.subcategoryKey || null,
//         experienceYears:
//           j.experienceYears === "" ? null : Number(j.experienceYears),
//       }))
//       .filter(
//         (j) =>
//           j.title ||
//           j.categoryKey ||
//           j.subcategoryKey ||
//           j.experienceYears != null
//       )
//       .slice(0, 5);

//     // Build combined address
//     const combinedAddress = [
//       form.address?.trim() ? `Address: ${form.address.trim()}` : null,
//       form.mandal?.trim() ? `Mandal: ${form.mandal.trim()}` : null,
//       form.district?.trim() ? `District: ${form.district.trim()}` : null,
//       form.state?.trim() ? `State: ${form.state.trim()}` : null,
//     ]
//       .filter(Boolean)
//       .join(", ");

//     setBusy(true);
//     try {
//       await ensureSignedIn(); // for storage rules

//       await createEmployeePublic({
//         firstName: form.firstName.trim(),
//         lastName: form.lastName.trim(),
//         fatherName: form.fatherName.trim(),

//         address: combinedAddress,
//         mobile: form.mobile.trim(),
//         email: form.email || null,

//         aadhaar: form.aadhaar.trim(),
//         pan: form.pan.trim(),

//         ids: completeIds,
//         profilePhotoUrl: form.profilePhotoUrl || "",

//         jobs,
//         availability: form.availability,
//         bio: form.bio,
//         status: "pending",
//       });

//       navigate("/employees/register/success");
//     } catch (err) {
//       console.error("Public register failed:", err);
//       setError(err);
//     } finally {
//       setBusy(false);
//     }
//   };

//   // ---------- UI ----------
//   return (
//     <section className="py-4">
//       <div className="container" style={{ maxWidth: 920 }}>
//         <h2 className="mb-3">Employee Registration</h2>
//         <p className="text-muted">
//           Create your account and submit details — Admin will review and approve
//           your profile.
//         </p>

//         {authError && (
//           <div className="alert alert-danger">
//             {authError.message || String(authError)}
//           </div>
//         )}

//         {/* STEP 1: Choose / Perform Auth */}
//         {authStep !== "done" ? (
//           <div className="card shadow-sm mb-3">
//             <div className="card-body">
//               <h5 className="card-title">Create Your Account</h5>

//               {authStep === "choose" && (
//                 <div className="d-flex gap-2 flex-wrap">
//                   <button
//                     type="button"
//                     className="btn btn-primary"
//                     onClick={() => setAuthStep("email")}
//                   >
//                     Continue with Email &amp; Password
//                   </button>
//                   <button
//                     type="button"
//                     className="btn btn-outline-danger"
//                     onClick={handleGoogleSignup}
//                     disabled={authBusy}
//                   >
//                     {authBusy ? "Connecting..." : "Continue with Google"}
//                   </button>
//                 </div>
//               )}

//               {authStep === "email" && (
//                 <form className="row g-3 mt-2" onSubmit={handleEmailSignup}>
//                   <div className="col-12 col-md-6">
//                     <label className="form-label" htmlFor="regEmail">
//                       Email
//                     </label>
//                     <input
//                       id="regEmail"
//                       type="email"
//                       className="form-control"
//                       value={authEmail}
//                       onChange={(e) => setAuthEmail(e.target.value)}
//                       required
//                     />
//                   </div>
//                   <div className="col-12 col-md-6">
//                     <label className="form-label" htmlFor="regPassword">
//                       Password
//                     </label>
//                     <input
//                       id="regPassword"
//                       type="password"
//                       className="form-control"
//                       value={authPassword}
//                       onChange={(e) => setAuthPassword(e.target.value)}
//                       required
//                       autoComplete="new-password"
//                     />
//                   </div>
//                   <div className="col-12 d-flex gap-2">
//                     <button
//                       className="btn btn-primary"
//                       type="submit"
//                       disabled={authBusy}
//                     >
//                       {authBusy ? "Creating..." : "Create Account & Continue"}
//                     </button>
//                     <button
//                       type="button"
//                       className="btn btn-outline-secondary"
//                       onClick={() => setAuthStep("choose")}
//                     >
//                       Back
//                     </button>
//                   </div>
//                 </form>
//               )}
//             </div>
//           </div>
//         ) : null}

//         {/* STEP 2: Registration Form (shown after auth) */}
//         {authStep === "done" && (
//           <>
//             {(catError || subcatError || servicesError) && (
//               <div className="alert alert-warning">
//                 {catError && <>Categories: {catError.message}. </>}
//                 {subcatError && <>Subcategories: {subcatError.message}. </>}
//                 {servicesError && <>Services: {servicesError.message}. </>}
//               </div>
//             )}

//             {error && (
//               <div className="alert alert-danger">
//                 {error.message || String(error)}
//               </div>
//             )}

//             <form onSubmit={onSubmit}>
//               {/* Basic Information */}
//               <div className="card shadow-sm mb-3">
//                 <div className="card-body">
//                   <h5 className="card-title">Basic Information</h5>
//                   <div className="row g-3">
//                     <div className="col-12 col-md-4">
//                       <label className="form-label" htmlFor="firstName">
//                         First Name *
//                       </label>
//                       <input
//                         id="firstName"
//                         name="firstName"
//                         className="form-control"
//                         value={form.firstName}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>
//                     <div className="col-12 col-md-4">
//                       <label className="form-label" htmlFor="lastName">
//                         Surname
//                       </label>
//                       <input
//                         id="lastName"
//                         name="lastName"
//                         className="form-control"
//                         value={form.lastName}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-12 col-md-4">
//                       <label className="form-label" htmlFor="fatherName">
//                         Father Name
//                       </label>
//                       <input
//                         id="fatherName"
//                         name="fatherName"
//                         className="form-control"
//                         value={form.fatherName}
//                         onChange={handleChange}
//                       />
//                     </div>

//                     <div className="col-12 col-md-6">
//                       <label className="form-label" htmlFor="mobile">
//                         Mobile *
//                       </label>
//                       <input
//                         id="mobile"
//                         name="mobile"
//                         className="form-control"
//                         value={form.mobile}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>
//                     <div className="col-12 col-md-6">
//                       <label className="form-label" htmlFor="email">
//                         Email
//                       </label>
//                       <input
//                         id="email"
//                         name="email"
//                         type="email"
//                         className="form-control"
//                         value={form.email}
//                         onChange={handleChange}
//                         placeholder="(Prefilled from your account if available)"
//                       />
//                     </div>

//                     <div className="col-12">
//                       <label className="form-label" htmlFor="address">
//                         Address (Flat / Area / Landmark)
//                       </label>
//                       <textarea
//                         id="address"
//                         name="address"
//                         className="form-control"
//                         rows={2}
//                         value={form.address}
//                         onChange={handleChange}
//                         placeholder="Flat / Area / Landmark"
//                       />
//                     </div>

//                     {/* State / District / Mandal with ADD option */}
//                     <div className="col-12 col-md-4">
//                       <label className="form-label" htmlFor="state">
//                         State *
//                       </label>
//                       <select
//                         id="state"
//                         name="state"
//                         className="form-select"
//                         value={form.state}
//                         onChange={(e) => {
//                           const newState = e.target.value;
//                           setForm((f) => ({
//                             ...f,
//                             state: newState,
//                             district: "",
//                             mandal: "",
//                           }));
//                         }}
//                         required
//                       >
//                         <option value="">(Select)</option>
//                         {statesList.map((s) => (
//                           <option key={s} value={s}>
//                             {s}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                     <div className="col-12 col-md-4">
//                       <label className="form-label" htmlFor="district">
//                         District *
//                       </label>
//                       <select
//                         id="district"
//                         name="district"
//                         className="form-select"
//                         value={form.district}
//                         onChange={(e) =>
//                           setForm((f) => ({
//                             ...f,
//                             district: e.target.value,
//                             mandal: "",
//                           }))
//                         }
//                         disabled={!form.state}
//                         required
//                       >
//                         {!form.state ? (
//                           <option value="">— Select State first —</option>
//                         ) : districtsForSelected.length === 0 ? (
//                           <option value="">— No districts found —</option>
//                         ) : (
//                           <>
//                             <option value="">(Select)</option>
//                             {districtsForSelected.map((d) => (
//                               <option key={d} value={d}>
//                                 {d}
//                               </option>
//                             ))}
//                           </>
//                         )}
//                       </select>
//                     </div>
//                     <div className="col-12 col-md-4">
//                       <label className="form-label" htmlFor="mandal">
//                         Mandal (optional)
//                       </label>
//                       <select
//                         id="mandal"
//                         name="mandal"
//                         className="form-select"
//                         value={
//                           mandalAddMode ? ADD_MANDAL_SENTINEL : form.mandal
//                         }
//                         onChange={(e) => {
//                           const val = e.target.value;
//                           if (val === ADD_MANDAL_SENTINEL) {
//                             setMandalAddMode(true);
//                             setForm((f) => ({ ...f, mandal: "" }));
//                           } else {
//                             setMandalAddMode(false);
//                             setForm((f) => ({ ...f, mandal: val }));
//                           }
//                         }}
//                         disabled={!form.district}
//                       >
//                         {!form.district ? (
//                           <option value="">— Select District first —</option>
//                         ) : mandalsForSelected.length === 0 ? (
//                           <>
//                             <option value="">(None)</option>
//                             <option value={ADD_MANDAL_SENTINEL}>
//                               + Add mandal not listed…
//                             </option>
//                           </>
//                         ) : (
//                           <>
//                             <option value="">(None)</option>
//                             {mandalsForSelected.map((m) => (
//                               <option key={m} value={m}>
//                                 {m}
//                               </option>
//                             ))}
//                             <option value={ADD_MANDAL_SENTINEL}>
//                               + Add mandal not listed…
//                             </option>
//                           </>
//                         )}
//                       </select>

//                       {mandalAddMode && (
//                         <div className="mt-2 d-flex gap-2">
//                           <input
//                             type="text"
//                             className="form-control"
//                             placeholder="Enter mandal name"
//                             value={mandalInput}
//                             onChange={(e) => setMandalInput(e.target.value)}
//                           />
//                           <button
//                             type="button"
//                             className="btn btn-outline-primary"
//                             onClick={addCustomMandal}
//                             disabled={!mandalInput.trim()}
//                           >
//                             Save
//                           </button>
//                           <button
//                             type="button"
//                             className="btn btn-outline-secondary"
//                             onClick={() => {
//                               setMandalAddMode(false);
//                               setMandalInput("");
//                             }}
//                           >
//                             Cancel
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Govt IDs */}
//               <div className="card shadow-sm mb-3">
//                 <div className="card-body">
//                   <h5 className="card-title">Govt IDs</h5>
//                   <div className="row g-3">
//                     <div className="col-12 col-md-6">
//                       <label className="form-label" htmlFor="aadhaar">
//                         Aadhaar
//                       </label>
//                       <input
//                         id="aadhaar"
//                         name="aadhaar"
//                         className="form-control"
//                         value={form.aadhaar}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-12 col-md-6">
//                       <label className="form-label" htmlFor="pan">
//                         PAN
//                       </label>
//                       <input
//                         id="pan"
//                         name="pan"
//                         className="form-control"
//                         value={form.pan}
//                         onChange={handleChange}
//                       />
//                     </div>
//                   </div>

//                   <hr />

//                   <div className="d-flex align-items-center justify-content-between mb-2">
//                     <label className="form-label mb-0">
//                       Authorized ID Photos (min 2)
//                     </label>
//                     <button
//                       type="button"
//                       className="btn btn-outline-primary btn-sm"
//                       onClick={() => addIdRow()}
//                     >
//                       + Add ID
//                     </button>
//                   </div>

//                   {form.ids.map((row, i) => (
//                     <div className="row g-2 align-items-end mb-2" key={i}>
//                       <div className="col-12 col-md-3">
//                         <label className="form-label">ID Type</label>
//                         <select
//                           className="form-select"
//                           value={row.type}
//                           onChange={(e) =>
//                             handleIdChange(i, "type", e.target.value)
//                           }
//                         >
//                           <option value="">(Select)</option>
//                           {AUTHORIZED_ID_TYPES.map((t) => (
//                             <option key={t} value={t}>
//                               {t}
//                             </option>
//                           ))}
//                         </select>
//                       </div>
//                       <div className="col-12 col-md-4">
//                         <label className="form-label">ID Number</label>
//                         <input
//                           className="form-control"
//                           value={row.value}
//                           onChange={(e) =>
//                             handleIdChange(i, "value", e.target.value)
//                           }
//                           placeholder="Enter ID number"
//                         />
//                       </div>
//                       <div className="col-12 col-md-3">
//                         <label className="form-label">Upload Photo</label>
//                         <input
//                           type="file"
//                           accept="image/*"
//                           capture="environment"
//                           className="form-control"
//                           onChange={(e) => {
//                             const f = e.target.files?.[0];
//                             if (!f) return;
//                             setScanModal({
//                               show: true,
//                               title: "Scan Authorized ID",
//                               target: "id",
//                               idIndex: i,
//                               file: f,
//                               options: {
//                                 maxWidth: 1600,
//                                 maxHeight: 1600,
//                                 maxBytes: 500 * 1024,
//                                 mimeType: "image/jpeg",
//                                 initialQuality: 0.85,
//                               },
//                             });
//                           }}
//                         />
//                         {row.imageUrl && (
//                           <div className="mt-1">
//                             <a
//                               href={row.imageUrl}
//                               target="_blank"
//                               rel="noreferrer"
//                             >
//                               View uploaded image
//                             </a>
//                           </div>
//                         )}
//                       </div>
//                       <div className="col-12 col-md-2">
//                         {form.ids.length > 2 && (
//                           <button
//                             type="button"
//                             className="btn btn-outline-danger"
//                             onClick={() => removeIdRow(i)}
//                           >
//                             Remove
//                           </button>
//                         )}
//                       </div>
//                     </div>
//                   ))}
//                   <small className="text-muted">
//                     Attach clear photos of at least two IDs.
//                   </small>
//                 </div>
//               </div>

//               {/* Profile Photo */}
//               <div className="card shadow-sm mb-3">
//                 <div className="card-body">
//                   <h5 className="card-title">Profile Photo</h5>
//                   <input
//                     type="file"
//                     accept="image/*"
//                     capture="environment"
//                     className="form-control"
//                     onChange={(e) => {
//                       const f = e.target.files?.[0];
//                       if (!f) return;
//                       setScanModal({
//                         show: true,
//                         title: "Scan Profile Photo",
//                         target: "pp",
//                         idIndex: null,
//                         file: f,
//                         options: {
//                           maxWidth: 1024,
//                           maxHeight: 1024,
//                           maxBytes: 300 * 1024,
//                           mimeType: "image/jpeg",
//                           initialQuality: 0.85,
//                         },
//                       });
//                     }}
//                   />
//                   {form.profilePhotoUrl && (
//                     <div className="mt-1">
//                       <a
//                         href={form.profilePhotoUrl}
//                         target="_blank"
//                         rel="noreferrer"
//                       >
//                         View photo
//                       </a>
//                     </div>
//                   )}
//                 </div>
//               </div>

//               {/* Job Preferences (optional) — now Category → Subcategory → Job Title */}
//               <div className="card shadow-sm mb-3">
//                 <div className="card-body">
//                   <h5 className="card-title">Job Preferences (optional)</h5>

//                   <div className="row g-2">
//                     <div className="col-12 col-md-3">
//                       <label className="form-label">Category</label>
//                       <select
//                         className="form-select"
//                         value={form.jobs[0]?.categoryKey || ""}
//                         onChange={(e) => onJobCategoryChange(0, e.target.value)}
//                       >
//                         {activeCats.length === 0 ? (
//                           <option value="">— No categories —</option>
//                         ) : (
//                           activeCats.map((c) => (
//                             <option key={c.id} value={c.key}>
//                               {c.label || c.key}
//                             </option>
//                           ))
//                         )}
//                       </select>
//                     </div>

//                     <div className="col-12 col-md-3">
//                       <label className="form-label">Subcategory</label>
//                       <select
//                         className="form-select"
//                         value={form.jobs[0]?.subcategoryKey || ""}
//                         onChange={(e) =>
//                           onJobSubcategoryChange(0, e.target.value)
//                         }
//                         disabled={!form.jobs[0]?.categoryKey}
//                       >
//                         {!form.jobs[0]?.categoryKey ? (
//                           <option value="">— Select category first —</option>
//                         ) : (subcatsByCat.get(form.jobs[0]?.categoryKey) || [])
//                             .length === 0 ? (
//                           <option value="">— No subcategories —</option>
//                         ) : (
//                           <>
//                             <option value="">(None)</option>
//                             {(
//                               subcatsByCat.get(form.jobs[0]?.categoryKey) || []
//                             ).map((s) => (
//                               <option key={s.id} value={s.key}>
//                                 {s.label || s.key}
//                               </option>
//                             ))}
//                           </>
//                         )}
//                       </select>
//                     </div>

//                     <div className="col-12 col-md-4">
//                       <label className="form-label">Job Title</label>
//                       <select
//                         className="form-select"
//                         value={form.jobs[0]?.title || ""}
//                         onChange={(e) =>
//                           handleJobChange(0, "title", e.target.value)
//                         }
//                         disabled={!form.jobs[0]?.categoryKey}
//                       >
//                         {!form.jobs[0]?.categoryKey ? (
//                           <option value="">— Select category first —</option>
//                         ) : (
//                           (() => {
//                             const bucketKey = `${form.jobs[0]?.categoryKey}|${
//                               form.jobs[0]?.subcategoryKey || ""
//                             }`;
//                             const titles =
//                               jobTitlesByCatSub.get(bucketKey) || [];
//                             return titles.length === 0 ? (
//                               <option value="">
//                                 — No services configured —
//                               </option>
//                             ) : (
//                               <>
//                                 <option value="">(Select)</option>
//                                 {titles.map((t, i) => (
//                                   <option
//                                     key={`${bucketKey}-${i}`}
//                                     value={t.label}
//                                   >
//                                     {t.label}
//                                   </option>
//                                 ))}
//                               </>
//                             );
//                           })()
//                         )}
//                       </select>
//                       <small className="text-muted">
//                         Titles come from Services under the selected
//                         Category/Subcategory.
//                       </small>
//                     </div>

//                     <div className="col-12 col-md-2">
//                       <label className="form-label">Experience (years)</label>
//                       <input
//                         className="form-control"
//                         type="number"
//                         min="0"
//                         value={form.jobs[0]?.experienceYears || ""}
//                         onChange={(e) =>
//                           handleJobChange(0, "experienceYears", e.target.value)
//                         }
//                       />
//                     </div>
//                   </div>

//                   <div className="row g-2 mt-2">
//                     <div className="col-12 col-md-3">
//                       <label className="form-label">Availability</label>
//                       <select
//                         className="form-select"
//                         name="availability"
//                         value={form.availability}
//                         onChange={handleChange}
//                       >
//                         <option value="full-time">Full-time</option>
//                         <option value="part-time">Part-time</option>
//                         <option value="contract">Contract</option>
//                         <option value="on-call">On-call</option>
//                       </select>
//                     </div>
//                     <div className="col-12">
//                       <label className="form-label">
//                         About you (short bio)
//                       </label>
//                       <textarea
//                         className="form-control"
//                         rows={3}
//                         name="bio"
//                         value={form.bio}
//                         onChange={handleChange}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Submit */}
//               <div className="d-flex gap-2">
//                 <button
//                   className="btn btn-primary"
//                   type="submit"
//                   disabled={busy}
//                 >
//                   {busy ? "Submitting..." : "Submit Registration"}
//                 </button>
//                 <a className="btn btn-outline-secondary" href="/">
//                   Cancel
//                 </a>
//               </div>
//             </form>
//           </>
//         )}
//       </div>

//       {/* Scan/Compress/Upload modal */}
//       <DocumentScanModal
//         show={scanModal.show}
//         file={scanModal.file}
//         title={scanModal.title}
//         options={scanModal.options}
//         onCancel={() => setScanModal((s) => ({ ...s, show: false }))}
//         onConfirm={async (compressedBlob) => {
//           try {
//             await ensureSignedIn(); // anonymous auth
//             const mobileSafe = String(form.mobile || "public").replace(
//               /[^\w.-]/g,
//               "_"
//             );

//             if (scanModal.target === "id") {
//               const fileName = `id-${scanModal.idIndex + 1}.jpg`;
//               const { url } = await uploadToStorage(
//                 compressedBlob,
//                 `public/${mobileSafe}/ids`,
//                 fileName
//               );
//               setForm((prev) => {
//                 const ids = [...(prev.ids || [])];
//                 if (
//                   typeof scanModal.idIndex === "number" &&
//                   ids[scanModal.idIndex]
//                 ) {
//                   ids[scanModal.idIndex] = {
//                     ...ids[scanModal.idIndex],
//                     imageUrl: url,
//                   };
//                 }
//                 return { ...prev, ids };
//               });
//             } else if (scanModal.target === "pp") {
//               const { url } = await uploadToStorage(
//                 compressedBlob,
//                 `public/${mobileSafe}/profile`,
//                 `profile.jpg`
//               );
//               setForm((f) => ({ ...f, profilePhotoUrl: url }));
//             }
//           } catch (e) {
//             console.error(e);
//             setError(e);
//           } finally {
//             setScanModal((s) => ({ ...s, show: false }));
//           }
//         }}
//       />
//     </section>
//   );
// }

// import React, { useEffect, useMemo, useState } from "react";
// import { useNavigate } from "react-router-dom";

// import { createEmployeePublic } from "../../lib/employeesApi";
// import {
//   ensureSignedIn, // anonymous auth for storage/upload rules
//   signUpWithEmailPassword,
//   signInWithGoogle,
//   getCurrentUser,
// } from "../../lib/authSession";

// import {
//   subscribeCategories,
//   subscribeSubcategories,
//   subscribeServiceItems,
// } from "../../lib/servicesApi";

// import DocumentScanModal from "../../Components/DocumentScanModal";
// import { uploadToStorage } from "../../utils/storage";

// // Location datasets
// import locationNation from "../../data/locationNation.json"; // states & districts
// import locationData from "../../data/locationData.json"; // districts -> mandals

// const AUTHORIZED_ID_TYPES = [
//   "Aadhaar",
//   "PAN",
//   "VoterID",
//   "Driving License",
//   "Passport",
//   "EShram",
//   "Employee ID",
//   "Other",
// ];

// // ---- helpers to read mandals irrespective of exact JSON shape ----
// function buildMandalsIndex(raw) {
//   const byDistrict = new Map();

//   // Shape A: { districts: [ { district, mandals } ] }
//   if (raw?.districts && Array.isArray(raw.districts)) {
//     raw.districts.forEach((d) => {
//       const name = (d?.district || "").trim();
//       const list = Array.isArray(d?.mandals) ? d.mandals : [];
//       if (name) byDistrict.set(name, list);
//     });
//     return byDistrict;
//   }

//   // Shape B: { states: [ { state, districts: [ { district, mandals } ] } ] }
//   if (raw?.states && Array.isArray(raw.states)) {
//     raw.states.forEach((s) => {
//       (s?.districts || []).forEach((d) => {
//         const name = (d?.district || "").trim();
//         const list = Array.isArray(d?.mandals) ? d.mandals : [];
//         if (name) byDistrict.set(name, list);
//       });
//     });
//     return byDistrict;
//   }

//   // Fallback (empty)
//   return byDistrict;
// }

// const mandalsByDistrict = buildMandalsIndex(locationData);
// const ADD_MANDAL_SENTINEL = "__ADD_MANDA__";

// export default function EmployeesPublicRegister() {
//   const navigate = useNavigate();

//   // ---------- Auth ----------
//   const [authStep, setAuthStep] = useState("choose"); // "choose" | "email" | "done"
//   const [authBusy, setAuthBusy] = useState(false);
//   const [authError, setAuthError] = useState(null);
//   const [authEmail, setAuthEmail] = useState("");
//   const [authPassword, setAuthPassword] = useState("");

//   useEffect(() => {
//     const u = getCurrentUser?.();
//     if (u) {
//       setForm((f) => ({
//         ...f,
//         email: u.email || f.email,
//         firstName: u.displayName?.split(" ")?.[0] || f.firstName,
//         lastName: u.displayName?.split(" ")?.slice(1).join(" ") || f.lastName,
//       }));
//       setAuthStep("done");
//     }
//   }, []);

//   const handleEmailSignup = async (e) => {
//     e.preventDefault();
//     setAuthError(null);
//     if (!authEmail || !authPassword) {
//       setAuthError(new Error("Email and Password are required."));
//       return;
//     }
//     try {
//       setAuthBusy(true);
//       const user = await signUpWithEmailPassword(
//         authEmail.trim(),
//         authPassword,
//       );
//       setForm((f) => ({
//         ...f,
//         email: user.email || authEmail.trim(),
//         firstName: user.displayName?.split(" ")?.[0] || f.firstName,
//         lastName:
//           user.displayName?.split(" ")?.slice(1).join(" ") || f.lastName,
//       }));
//       setAuthStep("done");
//     } catch (err) {
//       console.error("Email signup failed:", err);
//       setAuthError(err);
//     } finally {
//       setAuthBusy(false);
//     }
//   };

//   const handleGoogleSignup = async () => {
//     setAuthError(null);
//     try {
//       setAuthBusy(true);
//       const user = await signInWithGoogle();
//       if (user?.uid) {
//         setForm((f) => ({
//           ...f,
//           email: user.email || f.email,
//           firstName: user.displayName?.split(" ")?.[0] || f.firstName,
//           lastName:
//             user.displayName?.split(" ")?.slice(1).join(" ") || f.lastName,
//         }));
//         setAuthStep("done");
//       }
//     } catch (err) {
//       console.error("Google sign-in failed:", err);
//       setAuthError(err);
//     } finally {
//       setAuthBusy(false);
//     }
//   };

//   // ---------- Upload modal ----------
//   const [scanModal, setScanModal] = useState({
//     show: false,
//     title: "",
//     target: null, // 'id' | 'pp'
//     idIndex: null,
//     file: null,
//     options: {},
//   });

//   // ---------- Form ----------
//   const [busy, setBusy] = useState(false);
//   const [error, setError] = useState(null);

//   const [form, setForm] = useState({
//     firstName: "",
//     lastName: "",
//     fatherName: "",
//     mobile: "",
//     email: "",

//     // Address
//     address: "",
//     state: "",
//     district: "",
//     mandal: "",

//     aadhaar: "",
//     pan: "",

//     // IDs: min 2
//     ids: [
//       { type: "", value: "", imageUrl: "" },
//       { type: "", value: "", imageUrl: "" },
//     ],

//     // Optional profile
//     profilePhotoUrl: "",

//     // Job preferences
//     jobs: [
//       { title: "", categoryKey: "", subcategoryKey: "", experienceYears: "" },
//     ],

//     availability: "full-time",
//     bio: "",
//   });

//   // ---------- Location selectors ----------
//   const statesList = useMemo(
//     () => (locationNation?.states || []).map((s) => s.state),
//     [],
//   );
//   const districtsByState = useMemo(() => {
//     const map = new Map();
//     (locationNation?.states || []).forEach((s) => {
//       map.set(s.state, s.districts || []);
//     });
//     return map;
//   }, []);

//   // Custom mandals added by the user per district (in-memory)
//   const [customMandals, setCustomMandals] = useState(new Map());
//   const [mandalAddMode, setMandalAddMode] = useState(false);
//   const [mandalInput, setMandalInput] = useState("");

//   const districtsForSelected = useMemo(
//     () => districtsByState.get(form.state) || [],
//     [districtsByState, form.state],
//   );

//   const mandalsForSelected = useMemo(() => {
//     const base = mandalsByDistrict.get(form.district) || [];
//     const extra = customMandals.get(form.district) || [];
//     // unique merge
//     return Array.from(new Set([...base, ...extra]));
//   }, [form.district, customMandals]);

//   const addCustomMandal = () => {
//     const m = (mandalInput || "").trim();
//     if (!m) return;
//     const next = new Map(customMandals);
//     const arr = next.get(form.district) || [];
//     if (!arr.includes(m)) arr.push(m);
//     next.set(form.district, arr);
//     setCustomMandals(next);
//     setForm((f) => ({ ...f, mandal: m }));
//     setMandalAddMode(false);
//     setMandalInput("");
//   };

//   // reset when state/district changes
//   useEffect(() => {
//     setForm((f) => ({ ...f, district: "", mandal: "" }));
//     setMandalAddMode(false);
//     setMandalInput("");
//   }, [form.state]);
//   useEffect(() => {
//     setForm((f) => ({ ...f, mandal: "" }));
//     setMandalAddMode(false);
//     setMandalInput("");
//   }, [form.district]);

//   // ---------- Services (Categories/Subcategories/Job Titles) ----------
//   const [cats, setCats] = useState([]);
//   const [subcats, setSubcats] = useState([]);
//   const [services, setServices] = useState([]);
//   const [catError, setCatError] = useState(null);
//   const [subcatError, setSubcatError] = useState(null);
//   const [servicesError, setServicesError] = useState(null);

//   useEffect(() => subscribeCategories(setCats, setCatError), []);
//   useEffect(() => subscribeSubcategories(setSubcats, setSubcatError), []);
//   useEffect(
//     () => subscribeServiceItems?.(setServices, setServicesError, {}),
//     [],
//   );

//   // Only active categories
//   const activeCats = useMemo(
//     () => (cats || []).filter((c) => c.active),
//     [cats],
//   );

//   // Lookup labels by key for category/subcategory
//   const catLabelByKey = useMemo(() => {
//     const m = new Map();
//     (activeCats || []).forEach((c) => m.set(c.key, c.label || c.key));
//     return m;
//   }, [activeCats]);

//   const subLabelByKey = useMemo(() => {
//     const m = new Map();
//     (subcats || []).forEach((s) => m.set(s.key, s.label || s.key));
//     return m;
//   }, [subcats]);

//   // Flatten all services into a Title-first index
//   // Each item: { id, label, categoryKey, subcategoryKey, catLabel, subLabel }
//   const allJobTitles = useMemo(() => {
//     const list = [];
//     (services || [])
//       .filter((s) => s?.isActive !== false)
//       .forEach((s) => {
//         const catKey = s.category || "";
//         const subKey = s.subcategory || "";
//         const label = s.name || s.slug || "-";
//         // Stable id per (cat, subcat, label) tuple
//         const id = `${catKey}__${subKey}__${label}`;
//         list.push({
//           id,
//           label,
//           categoryKey: catKey,
//           subcategoryKey: subKey,
//           catLabel: catLabelByKey.get(catKey) || catKey,
//           subLabel: subLabelByKey.get(subKey) || subKey,
//         });
//       });

//     // sort by label
//     list.sort((a, b) => (a.label || "").localeCompare(b.label || ""));

//     // de-duplicate by id
//     const out = [];
//     let lastId = null;
//     for (const item of list) {
//       if (item.id !== lastId) {
//         out.push(item);
//         lastId = item.id;
//       }
//     }
//     return out;
//   }, [services, catLabelByKey, subLabelByKey]);

//   const titleById = useMemo(() => {
//     const m = new Map();
//     allJobTitles.forEach((t) => m.set(t.id, t));
//     return m;
//   }, [allJobTitles]);

//   // Simple search/filter
//   const [titleQuery, setTitleQuery] = useState("");
//   const filteredTitles = useMemo(() => {
//     const q = titleQuery.trim().toLowerCase();
//     if (!q) return allJobTitles;
//     return allJobTitles.filter((t) => {
//       return (
//         (t.label || "").toLowerCase().includes(q) ||
//         (t.catLabel || "").toLowerCase().includes(q) ||
//         (t.subLabel || "").toLowerCase().includes(q)
//       );
//     });
//   }, [titleQuery, allJobTitles]);

//   // --------- (Old) Subcat and Title maps kept for possible future use ----------
//   const subcatsByCat = useMemo(() => {
//     const map = new Map();
//     (subcats || []).forEach((s) => {
//       const arr = map.get(s.categoryKey) || [];
//       arr.push(s);
//       map.set(s.categoryKey, arr);
//     });
//     for (const [k, v] of map) {
//       v.sort((a, b) => (a.label || "").localeCompare(b.label || ""));
//       map.set(k, v);
//     }
//     return map;
//   }, [subcats]);

//   const jobTitlesByCatSub = useMemo(() => {
//     const map = new Map();
//     (services || [])
//       .filter((s) => s?.isActive !== false)
//       .forEach((s) => {
//         const catKey = s.category || "";
//         const subKey = s.subcategory || "";
//         const key = `${catKey}|${subKey}`;
//         const list = map.get(key) || [];
//         list.push({ value: s.slug || s.name, label: s.name || s.slug || "-" });
//         map.set(key, list);
//       });
//     for (const [k, v] of map) {
//       v.sort((a, b) => (a.label || "").localeCompare(b.label || ""));
//       map.set(k, v);
//     }
//     return map;
//   }, [services]);

//   // NOTE: We intentionally remove the old "defaults for first job row when services load".
//   // We want the user to pick a Job Title first, so no auto selection here.

//   const handleJobChange = (index, key, value) => {
//     setForm((f) => {
//       const jobs = [...f.jobs];
//       jobs[index] = { ...jobs[index], [key]: value };
//       return { ...f, jobs };
//     });
//   };

//   const onSelectJobTitle = (id) => {
//     const t = titleById.get(id);
//     setForm((f) => {
//       const jobs = [...f.jobs];
//       jobs[0] = {
//         ...jobs[0],
//         title: t?.label || "",
//         categoryKey: t?.categoryKey || "",
//         subcategoryKey: t?.subcategoryKey || "",
//       };
//       return { ...f, jobs };
//     });
//   };

//   // ---------- Handlers ----------
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((f) => ({ ...f, [name]: value }));
//   };

//   const handleIdChange = (index, key, value) => {
//     setForm((f) => {
//       const ids = [...f.ids];
//       const v = typeof value === "string" ? value.trim() : value;
//       ids[index] = { ...ids[index], [key]: v };
//       return { ...f, ids };
//     });
//   };

//   const addIdRow = () =>
//     setForm((f) => ({
//       ...f,
//       ids: [...f.ids, { type: "", value: "", imageUrl: "" }],
//     }));

//   const removeIdRow = (index) =>
//     setForm((f) => ({ ...f, ids: f.ids.filter((_, i) => i !== index) }));

//   const onSubmit = async (e) => {
//     e.preventDefault();
//     setError(null);

//     if (!form.firstName || !form.mobile) {
//       setError(new Error("Please fill First Name and Mobile."));
//       return;
//     }
//     if (!form.state || !form.district) {
//       setError(new Error("Please select State and District."));
//       return;
//     }

//     const normalizeId = (r = {}) => ({
//       type: String(r.type || "").trim(),
//       value: String(r.value || "").trim(),
//       imageUrl: String(r.imageUrl || "").trim(),
//     });
//     const completeIds = (form.ids || [])
//       .map(normalizeId)
//       .filter((r) => r.type && r.value && r.imageUrl);
//     if (completeIds.length < 2) {
//       setError(
//         new Error("Please attach at least two Authorized IDs with photos."),
//       );
//       return;
//     }

//     // Normalize jobs: keep any row that has something
//     const jobs = (form.jobs || [])
//       .map((j) => ({
//         title: String(j.title || "").trim(),
//         categoryKey: j.categoryKey || null,
//         subcategoryKey: j.subcategoryKey || null,
//         experienceYears:
//           j.experienceYears === "" ? null : Number(j.experienceYears),
//       }))
//       .filter(
//         (j) =>
//           j.title ||
//           j.categoryKey ||
//           j.subcategoryKey ||
//           j.experienceYears != null,
//       )
//       .slice(0, 5);

//     // Build combined address
//     const combinedAddress = [
//       form.address?.trim() ? `Address: ${form.address.trim()}` : null,
//       form.mandal?.trim() ? `Mandal: ${form.mandal.trim()}` : null,
//       form.district?.trim() ? `District: ${form.district.trim()}` : null,
//       form.state?.trim() ? `State: ${form.state.trim()}` : null,
//     ]
//       .filter(Boolean)
//       .join(", ");

//     setBusy(true);
//     try {
//       await ensureSignedIn(); // for storage rules

//       await createEmployeePublic({
//         firstName: form.firstName.trim(),
//         lastName: form.lastName.trim(),
//         fatherName: form.fatherName.trim(),

//         address: combinedAddress,
//         mobile: form.mobile.trim(),
//         email: form.email || null,

//         aadhaar: form.aadhaar.trim(),
//         pan: form.pan.trim(),

//         ids: completeIds,
//         profilePhotoUrl: form.profilePhotoUrl || "",

//         jobs,
//         availability: form.availability,
//         bio: form.bio,
//         status: "pending",
//       });

//       navigate("/employees/register/success");
//     } catch (err) {
//       console.error("Public register failed:", err);
//       setError(err);
//     } finally {
//       setBusy(false);
//     }
//   };

//   // ---------- UI ----------
//   // Utility to reflect current selected job into the <select> value
//   const currentJobId = useMemo(() => {
//     const j0 = form.jobs?.[0] || {};
//     const id = `${j0.categoryKey || ""}__${j0.subcategoryKey || ""}__${j0.title || ""}`;
//     return titleById.has(id) ? id : "";
//   }, [form.jobs, titleById]);

//   return (
//     <section className="py-4">
//       <div className="container" style={{ maxWidth: 920 }}>
//         <h2 className="mb-3">Employee Registration</h2>
//         <p className="text-muted">
//           Create your account and submit details — Admin will review and approve
//           your profile.
//         </p>

//         {authError && (
//           <div className="alert alert-danger">
//             {authError.message || String(authError)}
//           </div>
//         )}

//         {/* STEP 1: Choose / Perform Auth */}
//         {authStep !== "done" ? (
//           <div className="card shadow-sm mb-3">
//             <div className="card-body">
//               <h5 className="card-title">Create Your Account</h5>

//               {authStep === "choose" && (
//                 <div className="d-flex gap-2 flex-wrap">
//                   <button
//                     type="button"
//                     className="btn btn-primary"
//                     onClick={() => setAuthStep("email")}
//                   >
//                     Continue with Email &amp; Password
//                   </button>
//                   <button
//                     type="button"
//                     className="btn btn-outline-danger"
//                     onClick={handleGoogleSignup}
//                     disabled={authBusy}
//                   >
//                     {authBusy ? "Connecting..." : "Continue with Google"}
//                   </button>
//                 </div>
//               )}

//               {authStep === "email" && (
//                 <form className="row g-3 mt-2" onSubmit={handleEmailSignup}>
//                   <div className="col-12 col-md-6">
//                     <label className="form-label" htmlFor="regEmail">
//                       Email
//                     </label>
//                     <input
//                       id="regEmail"
//                       type="email"
//                       className="form-control"
//                       value={authEmail}
//                       onChange={(e) => setAuthEmail(e.target.value)}
//                       required
//                     />
//                   </div>
//                   <div className="col-12 col-md-6">
//                     <label className="form-label" htmlFor="regPassword">
//                       Password
//                     </label>
//                     <input
//                       id="regPassword"
//                       type="password"
//                       className="form-control"
//                       value={authPassword}
//                       onChange={(e) => setAuthPassword(e.target.value)}
//                       required
//                       autoComplete="new-password"
//                     />
//                   </div>
//                   <div className="col-12 d-flex gap-2">
//                     <button
//                       className="btn btn-primary"
//                       type="submit"
//                       disabled={authBusy}
//                     >
//                       {authBusy
//                         ? "Creating..."
//                         : "Create Account &amp; Continue"}
//                     </button>
//                     <button
//                       type="button"
//                       className="btn btn-outline-secondary"
//                       onClick={() => setAuthStep("choose")}
//                     >
//                       Back
//                     </button>
//                   </div>
//                 </form>
//               )}
//             </div>
//           </div>
//         ) : null}

//         {/* STEP 2: Registration Form (shown after auth) */}
//         {authStep === "done" && (
//           <>
//             {(catError || subcatError || servicesError) && (
//               <div className="alert alert-warning">
//                 {catError && <>Categories: {catError.message}. </>}
//                 {subcatError && <>Subcategories: {subcatError.message}. </>}
//                 {servicesError && <>Services: {servicesError.message}. </>}
//               </div>
//             )}

//             {error && (
//               <div className="alert alert-danger">
//                 {error.message || String(error)}
//               </div>
//             )}

//             <form onSubmit={onSubmit}>
//               {/* Basic Information */}
//               <div className="card shadow-sm mb-3">
//                 <div className="card-body">
//                   <h5 className="card-title">Basic Information</h5>
//                   <div className="row g-3">
//                     <div className="col-12 col-md-4">
//                       <label className="form-label" htmlFor="firstName">
//                         First Name *
//                       </label>
//                       <input
//                         id="firstName"
//                         name="firstName"
//                         className="form-control"
//                         value={form.firstName}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>
//                     <div className="col-12 col-md-4">
//                       <label className="form-label" htmlFor="lastName">
//                         Surname
//                       </label>
//                       <input
//                         id="lastName"
//                         name="lastName"
//                         className="form-control"
//                         value={form.lastName}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-12 col-md-4">
//                       <label className="form-label" htmlFor="fatherName">
//                         Father Name
//                       </label>
//                       <input
//                         id="fatherName"
//                         name="fatherName"
//                         className="form-control"
//                         value={form.fatherName}
//                         onChange={handleChange}
//                       />
//                     </div>

//                     <div className="col-12 col-md-6">
//                       <label className="form-label" htmlFor="mobile">
//                         Mobile *
//                       </label>
//                       <input
//                         id="mobile"
//                         name="mobile"
//                         className="form-control"
//                         value={form.mobile}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>
//                     <div className="col-12 col-md-6">
//                       <label className="form-label" htmlFor="email">
//                         Email
//                       </label>
//                       <input
//                         id="email"
//                         name="email"
//                         type="email"
//                         className="form-control"
//                         value={form.email}
//                         onChange={handleChange}
//                         placeholder="(Prefilled from your account if available)"
//                       />
//                     </div>

//                     <div className="col-12">
//                       <label className="form-label" htmlFor="address">
//                         Address (Flat / Area / Landmark)
//                       </label>
//                       <textarea
//                         id="address"
//                         name="address"
//                         className="form-control"
//                         rows={2}
//                         value={form.address}
//                         onChange={handleChange}
//                         placeholder="Flat / Area / Landmark"
//                       />
//                     </div>

//                     {/* State / District / Mandal with ADD option */}
//                     <div className="col-12 col-md-4">
//                       <label className="form-label" htmlFor="state">
//                         State *
//                       </label>
//                       <select
//                         id="state"
//                         name="state"
//                         className="form-select"
//                         value={form.state}
//                         onChange={(e) => {
//                           const newState = e.target.value;
//                           setForm((f) => ({
//                             ...f,
//                             state: newState,
//                             district: "",
//                             mandal: "",
//                           }));
//                         }}
//                         required
//                       >
//                         <option value="">(Select)</option>
//                         {statesList.map((s) => (
//                           <option key={s} value={s}>
//                             {s}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                     <div className="col-12 col-md-4">
//                       <label className="form-label" htmlFor="district">
//                         District *
//                       </label>
//                       <select
//                         id="district"
//                         name="district"
//                         className="form-select"
//                         value={form.district}
//                         onChange={(e) =>
//                           setForm((f) => ({
//                             ...f,
//                             district: e.target.value,
//                             mandal: "",
//                           }))
//                         }
//                         disabled={!form.state}
//                         required
//                       >
//                         {!form.state ? (
//                           <option value="">— Select State first —</option>
//                         ) : districtsForSelected.length === 0 ? (
//                           <option value="">— No districts found —</option>
//                         ) : (
//                           <>
//                             <option value="">(Select)</option>
//                             {districtsForSelected.map((d) => (
//                               <option key={d} value={d}>
//                                 {d}
//                               </option>
//                             ))}
//                           </>
//                         )}
//                       </select>
//                     </div>
//                     <div className="col-12 col-md-4">
//                       <label className="form-label" htmlFor="mandal">
//                         Mandal (optional)
//                       </label>
//                       <select
//                         id="mandal"
//                         name="mandal"
//                         className="form-select"
//                         value={
//                           mandalAddMode ? ADD_MANDAL_SENTINEL : form.mandal
//                         }
//                         onChange={(e) => {
//                           const val = e.target.value;
//                           if (val === ADD_MANDAL_SENTINEL) {
//                             setMandalAddMode(true);
//                             setForm((f) => ({ ...f, mandal: "" }));
//                           } else {
//                             setMandalAddMode(false);
//                             setForm((f) => ({ ...f, mandal: val }));
//                           }
//                         }}
//                         disabled={!form.district}
//                       >
//                         {!form.district ? (
//                           <option value="">— Select District first —</option>
//                         ) : mandalsForSelected.length === 0 ? (
//                           <>
//                             <option value="">(None)</option>
//                             <option value={ADD_MANDAL_SENTINEL}>
//                               + Add mandal not listed…
//                             </option>
//                           </>
//                         ) : (
//                           <>
//                             <option value="">(None)</option>
//                             {mandalsForSelected.map((m) => (
//                               <option key={m} value={m}>
//                                 {m}
//                               </option>
//                             ))}
//                             <option value={ADD_MANDAL_SENTINEL}>
//                               + Add mandal not listed…
//                             </option>
//                           </>
//                         )}
//                       </select>

//                       {mandalAddMode && (
//                         <div className="mt-2 d-flex gap-2">
//                           <input
//                             type="text"
//                             className="form-control"
//                             placeholder="Enter mandal name"
//                             value={mandalInput}
//                             onChange={(e) => setMandalInput(e.target.value)}
//                           />
//                           <button
//                             type="button"
//                             className="btn btn-outline-primary"
//                             onClick={addCustomMandal}
//                             disabled={!mandalInput.trim()}
//                           >
//                             Save
//                           </button>
//                           <button
//                             type="button"
//                             className="btn btn-outline-secondary"
//                             onClick={() => {
//                               setMandalAddMode(false);
//                               setMandalInput("");
//                             }}
//                           >
//                             Cancel
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Govt IDs */}
//               <div className="card shadow-sm mb-3">
//                 <div className="card-body">
//                   {/* <h5 className="card-title">Govt IDs</h5> */}
//                   {/* <div className="row g-3">
//                     <div className="col-12 col-md-6">
//                       <label className="form-label" htmlFor="aadhaar">
//                         Aadhaar
//                       </label>
//                       <input
//                         id="aadhaar"
//                         name="aadhaar"
//                         className="form-control"
//                         value={form.aadhaar}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div className="col-12 col-md-6">
//                       <label className="form-label" htmlFor="pan">
//                         PAN
//                       </label>
//                       <input
//                         id="pan"
//                         name="pan"
//                         className="form-control"
//                         value={form.pan}
//                         onChange={handleChange}
//                       />
//                     </div>
//                   </div> */}

//                   {/* <hr /> */}

//                   <div className="d-flex align-items-center justify-content-between mb-2">
//                     <div className="d-flex flex-row gap-3">
//                       <h5 className="card-title ">Govt IDs</h5>{" "}
//                       <small>
//                         <label className="form-label mb-0">
//                           (Authorized ID Photos 2)
//                         </label>
//                       </small>
//                     </div>
//                     <button
//                       type="button"
//                       className="btn btn-outline-primary btn-sm"
//                       onClick={() => addIdRow()}
//                     >
//                       + Add ID
//                     </button>
//                   </div>

//                   {form.ids.map((row, i) => (
//                     <div className="row g-2 align-items-end mb-2" key={i}>
//                       <div className="col-12 col-md-3">
//                         <label className="form-label">ID Type</label>
//                         <select
//                           className="form-select"
//                           value={row.type}
//                           onChange={(e) =>
//                             handleIdChange(i, "type", e.target.value)
//                           }
//                         >
//                           <option value="">(Select)</option>
//                           {AUTHORIZED_ID_TYPES.map((t) => (
//                             <option key={t} value={t}>
//                               {t}
//                             </option>
//                           ))}
//                         </select>
//                       </div>
//                       <div className="col-12 col-md-4">
//                         <label className="form-label">ID Number</label>
//                         <input
//                           className="form-control"
//                           value={row.value}
//                           onChange={(e) =>
//                             handleIdChange(i, "value", e.target.value)
//                           }
//                           placeholder="Enter ID number"
//                         />
//                       </div>
//                       <div className="col-12 col-md-3">
//                         <label className="form-label">Upload Photo</label>
//                         <input
//                           type="file"
//                           accept="image/*"
//                           capture="environment"
//                           className="form-control"
//                           onChange={(e) => {
//                             const f = e.target.files?.[0];
//                             if (!f) return;
//                             setScanModal({
//                               show: true,
//                               title: "Scan Authorized ID",
//                               target: "id",
//                               idIndex: i,
//                               file: f,
//                               options: {
//                                 maxWidth: 1600,
//                                 maxHeight: 1600,
//                                 maxBytes: 500 * 1024,
//                                 mimeType: "image/jpeg",
//                                 initialQuality: 0.85,
//                               },
//                             });
//                           }}
//                         />
//                         {row.imageUrl && (
//                           <div className="mt-1">
//                             <a
//                               href={row.imageUrl}
//                               target="_blank"
//                               rel="noreferrer"
//                             >
//                               View uploaded image
//                             </a>
//                           </div>
//                         )}
//                       </div>
//                       <div className="col-12 col-md-2">
//                         {form.ids.length > 2 && (
//                           <button
//                             type="button"
//                             className="btn btn-outline-danger"
//                             onClick={() => removeIdRow(i)}
//                           >
//                             Remove
//                           </button>
//                         )}
//                       </div>
//                     </div>
//                   ))}
//                   <small className="text-muted">
//                     Attach clear photos of at least two IDs.
//                   </small>
//                 </div>
//               </div>

//               {/* Profile Photo */}
//               <div className="card shadow-sm mb-3">
//                 <div className="card-body">
//                   <h5 className="card-title">Profile Photo</h5>
//                   <input
//                     type="file"
//                     accept="image/*"
//                     capture="environment"
//                     className="form-control"
//                     onChange={(e) => {
//                       const f = e.target.files?.[0];
//                       if (!f) return;
//                       setScanModal({
//                         show: true,
//                         title: "Scan Profile Photo",
//                         target: "pp",
//                         idIndex: null,
//                         file: f,
//                         options: {
//                           maxWidth: 1024,
//                           maxHeight: 1024,
//                           maxBytes: 300 * 1024,
//                           mimeType: "image/jpeg",
//                           initialQuality: 0.85,
//                         },
//                       });
//                     }}
//                   />
//                   {form.profilePhotoUrl && (
//                     <div className="mt-1">
//                       <a
//                         href={form.profilePhotoUrl}
//                         target="_blank"
//                         rel="noreferrer"
//                       >
//                         View photo
//                       </a>
//                     </div>
//                   )}
//                 </div>
//               </div>

//               {/* Job Preferences (optional) — Title-first */}
//               <div className="card shadow-sm mb-3">
//                 <div className="card-body">
//                   <h5 className="card-title">Job Preferences (optional)</h5>

//                   {/* Search box */}
//                   <div className="mb-2">
//                     <label className="form-label">Search Job Title</label>
//                     <input
//                       className="form-control"
//                       placeholder="Type to search e.g., Electrician, Plumber, Mason..."
//                       value={titleQuery}
//                       onChange={(e) => setTitleQuery(e.target.value)}
//                     />
//                   </div>

//                   <div className="row g-3 align-items-start">
//                     <div className="col-12 col-md-7">
//                       <label className="form-label">Job Title</label>
//                       <select
//                         className="form-select"
//                         size={6}
//                         value={currentJobId}
//                         onChange={(e) => onSelectJobTitle(e.target.value)}
//                         disabled={allJobTitles.length === 0}
//                       >
//                         {allJobTitles.length === 0 ? (
//                           <option value="">— No services configured —</option>
//                         ) : filteredTitles.length === 0 ? (
//                           <option value="">— No matches —</option>
//                         ) : (
//                           filteredTitles.map((t) => (
//                             <option key={t.id} value={t.id}>
//                               {t.label}
//                             </option>
//                           ))
//                         )}
//                       </select>
//                       <small className="text-muted">
//                         Pick a title; Category &amp; Subcategory are set
//                         automatically.
//                       </small>
//                     </div>

//                     <div className="col-12 col-md-3">
//                       <label className="form-label d-block">Category</label>
//                       <div className="form-control-plaintext fw-semibold">
//                         {catLabelByKey.get(form.jobs[0]?.categoryKey) || "—"}
//                       </div>
//                     </div>

//                     <div className="col-12 col-md-2">
//                       <label className="form-label d-block">Subcategory</label>
//                       <div className="form-control-plaintext fw-semibold">
//                         {subLabelByKey.get(form.jobs[0]?.subcategoryKey) || "—"}
//                       </div>
//                     </div>
//                   </div>

//                   <div className="row g-2 mt-2">
//                     <div className="col-12 col-md-2">
//                       <label className="form-label">Experience (years)</label>
//                       <input
//                         className="form-control"
//                         type="number"
//                         min="0"
//                         value={form.jobs[0]?.experienceYears || ""}
//                         onChange={(e) =>
//                           handleJobChange(0, "experienceYears", e.target.value)
//                         }
//                       />
//                     </div>

//                     <div className="col-12 col-md-3">
//                       <label className="form-label">Availability</label>
//                       <select
//                         className="form-select"
//                         name="availability"
//                         value={form.availability}
//                         onChange={handleChange}
//                       >
//                         <option value="full-time">Full-time</option>
//                         <option value="part-time">Part-time</option>
//                         <option value="contract">Contract</option>
//                         <option value="on-call">On-call</option>
//                       </select>
//                     </div>

//                     <div className="col-12">
//                       <label className="form-label">
//                         About you (short bio)
//                       </label>
//                       <textarea
//                         className="form-control"
//                         rows={3}
//                         name="bio"
//                         value={form.bio}
//                         onChange={handleChange}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Submit */}
//               <div className="d-flex gap-2">
//                 <button
//                   className="btn btn-primary"
//                   type="submit"
//                   disabled={busy}
//                 >
//                   {busy ? "Submitting..." : "Submit Registration"}
//                 </button>
//                 <a className="btn btn-outline-secondary" href="/">
//                   Cancel
//                 </a>
//               </div>
//             </form>
//           </>
//         )}
//       </div>

//       {/* Scan/Compress/Upload modal */}
//       <DocumentScanModal
//         show={scanModal.show}
//         file={scanModal.file}
//         title={scanModal.title}
//         options={scanModal.options}
//         onCancel={() => setScanModal((s) => ({ ...s, show: false }))}
//         onConfirm={async (compressedBlob) => {
//           try {
//             await ensureSignedIn(); // anonymous auth
//             const mobileSafe = String(form.mobile || "public").replace(
//               /[^\w.-]/g,
//               "_",
//             );

//             if (scanModal.target === "id") {
//               const fileName = `id-${scanModal.idIndex + 1}.jpg`;
//               const { url } = await uploadToStorage(
//                 compressedBlob,
//                 `public/${mobileSafe}/ids`,
//                 fileName,
//               );
//               setForm((prev) => {
//                 const ids = [...(prev.ids || [])];
//                 if (
//                   typeof scanModal.idIndex === "number" &&
//                   ids[scanModal.idIndex]
//                 ) {
//                   ids[scanModal.idIndex] = {
//                     ...ids[scanModal.idIndex],
//                     imageUrl: url,
//                   };
//                 }
//                 return { ...prev, ids };
//               });
//             } else if (scanModal.target === "pp") {
//               const { url } = await uploadToStorage(
//                 compressedBlob,
//                 `public/${mobileSafe}/profile`,
//                 `profile.jpg`,
//               );
//               setForm((f) => ({ ...f, profilePhotoUrl: url }));
//             }
//           } catch (e) {
//             console.error(e);
//             setError(e);
//           } finally {
//             setScanModal((s) => ({ ...s, show: false }));
//           }
//         }}
//       />
//     </section>
//   );
// }

import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

import { createEmployeePublic } from "../../lib/employeesApi";
import {
  ensureSignedIn, // anonymous auth for storage/upload rules
  signUpWithEmailPassword,
  signInWithGoogle,
  getCurrentUser,
} from "../../lib/authSession";

import {
  subscribeCategories,
  subscribeSubcategories,
  subscribeServiceItems,
} from "../../lib/servicesApi";

import DocumentScanModal from "../../Components/DocumentScanModal";
import { uploadToStorage } from "../../utils/storage";

// Location datasets
import locationNation from "../../data/locationNation.json"; // states & districts
import locationData from "../../data/locationData.json"; // districts -> mandals

const AUTHORIZED_ID_TYPES = [
  "Aadhaar",
  "PAN",
  "VoterID",
  "Driving License",
  "Passport",
  "EShram",
  "Ration Card",
  "Employee ID",
  "Other",
];

const MAX_JOBS = 5;

// ---- helpers to read mandals irrespective of exact JSON shape ----
function buildMandalsIndex(raw) {
  const byDistrict = new Map();

  // Shape A: { districts: [ { district, mandals } ] }
  if (raw?.districts && Array.isArray(raw.districts)) {
    raw.districts.forEach((d) => {
      const name = (d?.district || "").trim();
      const list = Array.isArray(d?.mandals) ? d.mandals : [];
      if (name) byDistrict.set(name, list);
    });
    return byDistrict;
  }

  // Shape B: { states: [ { state, districts: [ { district, mandals } ] } ] }
  if (raw?.states && Array.isArray(raw.states)) {
    raw.states.forEach((s) => {
      (s?.districts || []).forEach((d) => {
        const name = (d?.district || "").trim();
        const list = Array.isArray(d?.mandals) ? d.mandals : [];
        if (name) byDistrict.set(name, list);
      });
    });
    return byDistrict;
  }

  // Fallback (empty)
  return byDistrict;
}

const mandalsByDistrict = buildMandalsIndex(locationData);
const ADD_MANDAL_SENTINEL = "__ADD_MANDA__";

export default function EmployeesPublicRegister() {
  const navigate = useNavigate();

  // ---------- Auth ----------
  const [authStep, setAuthStep] = useState("choose"); // "choose" | "email" | "done"
  const [authBusy, setAuthBusy] = useState(false);
  const [authError, setAuthError] = useState(null);
  const [authEmail, setAuthEmail] = useState("");
  const [authPassword, setAuthPassword] = useState("");

  useEffect(() => {
    const u = getCurrentUser?.();
    if (u) {
      setForm((f) => ({
        ...f,
        email: u.email || f.email,
        firstName: u.displayName?.split(" ")?.[0] || f.firstName,
        lastName: u.displayName?.split(" ")?.slice(1).join(" ") || f.lastName,
      }));
      setAuthStep("done");
    }
  }, []);

  const handleEmailSignup = async (e) => {
    e.preventDefault();
    setAuthError(null);
    if (!authEmail || !authPassword) {
      setAuthError(new Error("Email and Password are required."));
      return;
    }
    try {
      setAuthBusy(true);
      const user = await signUpWithEmailPassword(
        authEmail.trim(),
        authPassword,
      );
      setForm((f) => ({
        ...f,
        email: user.email || authEmail.trim(),
        firstName: user.displayName?.split(" ")?.[0] || f.firstName,
        lastName:
          user.displayName?.split(" ")?.slice(1).join(" ") || f.lastName,
      }));
      setAuthStep("done");
    } catch (err) {
      console.error("Email signup failed:", err);
      setAuthError(err);
    } finally {
      setAuthBusy(false);
    }
  };

  const handleGoogleSignup = async () => {
    setAuthError(null);
    try {
      setAuthBusy(true);
      const user = await signInWithGoogle();
      if (user?.uid) {
        setForm((f) => ({
          ...f,
          email: user.email || f.email,
          firstName: user.displayName?.split(" ")?.[0] || f.firstName,
          lastName:
            user.displayName?.split(" ")?.slice(1).join(" ") || f.lastName,
        }));
        setAuthStep("done");
      }
    } catch (err) {
      console.error("Google sign-in failed:", err);
      setAuthError(err);
    } finally {
      setAuthBusy(false);
    }
  };

  // ---------- Upload modal ----------
  const [scanModal, setScanModal] = useState({
    show: false,
    title: "",
    target: null, // 'id' | 'pp'
    idIndex: null,
    file: null,
    options: {},
  });

  // ---------- Form ----------
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    fatherName: "",
    mobile: "",
    email: "",

    // Address
    address: "",
    state: "",
    district: "",
    mandal: "",

    aadhaar: "",
    pan: "",

    // IDs: min 2
    ids: [
      { type: "", value: "", imageUrl: "" },
      { type: "", value: "", imageUrl: "" },
    ],

    // Optional profile
    profilePhotoUrl: "",

    // Selected jobs (list)
    jobs: [],

    availability: "full-time",
    bio: "",
    role: "employee",
  });

  // ---------- Single Job Picker State ----------
  const [titleQuery, setTitleQuery] = useState("");
  const [pickerJobId, setPickerJobId] = useState(""); // currently selected option id in the picker
  const [lastAddedJobId, setLastAddedJobId] = useState(""); // for temporary highlight

  // ---------- Location selectors ----------
  const statesList = useMemo(
    () => (locationNation?.states || []).map((s) => s.state),
    [],
  );
  const districtsByState = useMemo(() => {
    const map = new Map();
    (locationNation?.states || []).forEach((s) => {
      map.set(s.state, s.districts || []);
    });
    return map;
  }, []);

  // Custom mandals added by the user per district (in-memory)
  const [customMandals, setCustomMandals] = useState(new Map());
  const [mandalAddMode, setMandalAddMode] = useState(false);
  const [mandalInput, setMandalInput] = useState("");

  const districtsForSelected = useMemo(
    () => districtsByState.get(form.state) || [],
    [districtsByState, form.state],
  );

  const mandalsForSelected = useMemo(() => {
    const base = mandalsByDistrict.get(form.district) || [];
    const extra = customMandals.get(form.district) || [];
    // unique merge
    return Array.from(new Set([...base, ...extra]));
  }, [form.district, customMandals]);

  const addCustomMandal = () => {
    const m = (mandalInput || "").trim();
    if (!m) return;
    const next = new Map(customMandals);
    const arr = next.get(form.district) || [];
    if (!arr.includes(m)) arr.push(m);
    next.set(form.district, arr);
    setCustomMandals(next);
    setForm((f) => ({ ...f, mandal: m }));
    setMandalAddMode(false);
    setMandalInput("");
  };

  // reset when state/district changes
  useEffect(() => {
    setForm((f) => ({ ...f, district: "", mandal: "" }));
    setMandalAddMode(false);
    setMandalInput("");
  }, [form.state]);
  useEffect(() => {
    setForm((f) => ({ ...f, mandal: "" }));
    setMandalAddMode(false);
    setMandalInput("");
  }, [form.district]);

  // ---------- Services (Categories/Subcategories/Job Titles) ----------
  const [cats, setCats] = useState([]);
  const [subcats, setSubcats] = useState([]);
  const [services, setServices] = useState([]);
  const [catError, setCatError] = useState(null);
  const [subcatError, setSubcatError] = useState(null);
  const [servicesError, setServicesError] = useState(null);

  useEffect(() => subscribeCategories(setCats, setCatError), []);
  useEffect(() => subscribeSubcategories(setSubcats, setSubcatError), []);
  useEffect(
    () => subscribeServiceItems?.(setServices, setServicesError, {}),
    [],
  );

  // Only active categories
  const activeCats = useMemo(
    () => (cats || []).filter((c) => c.active),
    [cats],
  );

  // Labels by key
  const catLabelByKey = useMemo(() => {
    const m = new Map();
    (activeCats || []).forEach((c) => m.set(c.key, c.label || c.key));
    return m;
  }, [activeCats]);

  const subLabelByKey = useMemo(() => {
    const m = new Map();
    (subcats || []).forEach((s) => m.set(s.key, s.label || s.key));
    return m;
  }, [subcats]);

  // Flatten services to Title-first list and maps
  const allJobTitles = useMemo(() => {
    const byId = new Map();
    (services || [])
      .filter((s) => s?.isActive !== false)
      .forEach((s) => {
        const catKey = s.category || "";
        const subKey = s.subcategory || "";
        const label = s.name || s.slug || "-";
        const id = `${catKey}__${subKey}__${label}`;
        if (!byId.has(id)) {
          byId.set(id, {
            id,
            label,
            categoryKey: catKey,
            subcategoryKey: subKey,
            catLabel: catLabelByKey.get(catKey) || catKey,
            subLabel: subLabelByKey.get(subKey) || subKey,
          });
        }
      });
    const arr = Array.from(byId.values());
    arr.sort((a, b) => (a.label || "").localeCompare(b.label || ""));
    return arr;
  }, [services, catLabelByKey, subLabelByKey]);

  const titleById = useMemo(() => {
    const m = new Map();
    allJobTitles.forEach((t) => m.set(t.id, t));
    return m;
  }, [allJobTitles]);

  const selectedJobIds = useMemo(() => {
    return new Set(
      (form.jobs || []).map(
        (j) =>
          `${j.categoryKey || ""}__${j.subcategoryKey || ""}__${j.title || ""}`,
      ),
    );
  }, [form.jobs]);

  const filteredTitles = useMemo(() => {
    const q = titleQuery.trim().toLowerCase();
    let list = allJobTitles.filter((t) => !selectedJobIds.has(t.id)); // remove already selected
    if (!q) return list;
    return list.filter(
      (t) =>
        (t.label || "").toLowerCase().includes(q) ||
        (t.catLabel || "").toLowerCase().includes(q) ||
        (t.subLabel || "").toLowerCase().includes(q),
    );
  }, [titleQuery, allJobTitles, selectedJobIds]);

  // When picker value becomes invalid (e.g., removed because selected), clear it
  useEffect(() => {
    if (pickerJobId && !filteredTitles.some((t) => t.id === pickerJobId)) {
      setPickerJobId("");
    }
  }, [filteredTitles, pickerJobId]);

  const pickerSelected = useMemo(() => {
    return pickerJobId ? titleById.get(pickerJobId) : null;
  }, [pickerJobId, titleById]);

  // ---------- IDs: unique type per row ----------
  const usedIdTypesExcept = (index) => {
    return new Set(
      (form.ids || [])
        .map((r, i) => (i !== index ? (r.type || "").trim() : ""))
        .filter(Boolean),
    );
  };
  const availableIdTypesFor = (index) => {
    const used = usedIdTypesExcept(index);
    return AUTHORIZED_ID_TYPES.filter((t) => !used.has(t));
  };

  // ---------- Jobs Actions ----------
  const addSelectedJob = () => {
    if (!pickerSelected) return;
    if ((form.jobs || []).length >= MAX_JOBS) return;

    const newJob = {
      title: pickerSelected.label,
      categoryKey: pickerSelected.categoryKey,
      subcategoryKey: pickerSelected.subcategoryKey,
      experienceYears: "",
    };
    const newId = `${newJob.categoryKey}__${newJob.subcategoryKey}__${newJob.title}`;
    if (selectedJobIds.has(newId)) return; // already selected

    setForm((f) => ({ ...f, jobs: [...(f.jobs || []), newJob] }));
    setLastAddedJobId(newId);

    // briefly highlight the newly added job
    setTimeout(() => setLastAddedJobId(""), 2000);
  };

  const removeJob = (index) => {
    setForm((f) => {
      const jobs = [...(f.jobs || [])];
      jobs.splice(index, 1);
      return { ...f, jobs };
    });
  };

  const handleJobExperienceChange = (index, value) => {
    setForm((f) => {
      const jobs = [...(f.jobs || [])];
      jobs[index] = {
        ...jobs[index],
        experienceYears: value,
      };
      return { ...f, jobs };
    });
  };

  // ---------- Generic Handlers ----------
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleIdChange = (index, key, value) => {
    setForm((f) => {
      const ids = [...f.ids];
      const v = typeof value === "string" ? value.trim() : value;
      ids[index] = { ...ids[index], [key]: v };
      return { ...f, ids };
    });
  };

  const addIdRow = () =>
    setForm((f) => ({
      ...f,
      ids: [...f.ids, { type: "", value: "", imageUrl: "" }],
    }));

  const removeIdRow = (index) =>
    setForm((f) => ({ ...f, ids: f.ids.filter((_, i) => i !== index) }));

  // ---------- Submit ----------
  const generateEmpId = () => {
    // Client-side generation; ensure server still enforces uniqueness!
    const num = Math.floor(Math.random() * 100_000_000);
    return `LP${num.toString().padStart(8, "0")}`;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (!form.firstName || !form.mobile) {
      setError(new Error("Please fill First Name and Mobile."));
      return;
    }
    if (!form.state || !form.district) {
      setError(new Error("Please select State and District."));
      return;
    }

    // Validate IDs (min 2, no duplicate types)
    const normalizeId = (r = {}) => ({
      type: String(r.type || "").trim(),
      value: String(r.value || "").trim(),
      imageUrl: String(r.imageUrl || "").trim(),
    });
    const completeIds = (form.ids || [])
      .map(normalizeId)
      .filter((r) => r.type && r.value && r.imageUrl);

    if (completeIds.length < 2) {
      setError(
        new Error("Please attach at least two Authorized IDs with photos."),
      );
      return;
    }

    const idTypeSet = new Set(completeIds.map((i) => i.type));
    if (idTypeSet.size !== completeIds.length) {
      setError(new Error("Duplicate Govt ID types are not allowed."));
      return;
    }

    // Normalize jobs: keep up to MAX_JOBS
    const jobs = (form.jobs || [])
      .map((j) => ({
        title: String(j.title || "").trim(),
        categoryKey: j.categoryKey || null,
        subcategoryKey: j.subcategoryKey || null,
        experienceYears:
          j.experienceYears === "" ? null : Number(j.experienceYears),
      }))
      .filter(
        (j) =>
          j.title ||
          j.categoryKey ||
          j.subcategoryKey ||
          j.experienceYears != null,
      )
      .slice(0, MAX_JOBS);

    // Build combined address
    const combinedAddress = [
      form.address?.trim() ? `Address: ${form.address.trim()}` : null,
      form.mandal?.trim() ? `Mandal: ${form.mandal.trim()}` : null,
      form.district?.trim() ? `District: ${form.district.trim()}` : null,
      form.state?.trim() ? `State: ${form.state.trim()}` : null,
    ]
      .filter(Boolean)
      .join(", ");

    // Create empId
    const empId = generateEmpId();

    setBusy(true);
    try {
      await ensureSignedIn(); // for storage rules

      await createEmployeePublic({
        empId, // NEW
        firstName: form.firstName.trim(),
        lastName: form.lastName.trim(),
        fatherName: form.fatherName.trim(),

        address: combinedAddress,
        mobile: form.mobile.trim(),
        email: form.email || null,

        aadhaar: form.aadhaar.trim(),
        pan: form.pan.trim(),

        ids: completeIds,
        profilePhotoUrl: form.profilePhotoUrl || "",

        jobs,
        availability: form.availability,
        bio: form.bio,
        status: "pending",
      });

      navigate("/employees/register/success");
    } catch (err) {
      console.error("Public register failed:", err);
      setError(err);
    } finally {
      setBusy(false);
    }
  };

  // ---------- UI ----------
  return (
    <section className="py-4">
      <div className="container" style={{ maxWidth: 920 }}>
        <h2 className="mb-3">Employee Registration</h2>
        <p className="text-muted">
          Create your account and submit details — Admin will review and approve
          your profile.
        </p>

        {authError && (
          <div className="alert alert-danger">
            {authError.message || String(authError)}
          </div>
        )}

        {/* STEP 1: Choose / Perform Auth */}
        {authStep !== "done" ? (
          <div className="card shadow-sm mb-3">
            <div className="card-body">
              <h5 className="card-title">Create Your Account</h5>

              {authStep === "choose" && (
                <div className="d-flex gap-2 flex-wrap">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => setAuthStep("email")}
                  >
                    Continue with Email &amp; Password
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-danger"
                    onClick={handleGoogleSignup}
                    disabled={authBusy}
                  >
                    {authBusy ? "Connecting..." : "Continue with Google"}
                  </button>
                </div>
              )}

              {authStep === "email" && (
                <form className="row g-3 mt-2" onSubmit={handleEmailSignup}>
                  <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor="regEmail">
                      Email
                    </label>
                    <input
                      id="regEmail"
                      type="email"
                      className="form-control"
                      value={authEmail}
                      onChange={(e) => setAuthEmail(e.target.value)}
                      required
                    />
                  </div>
                  <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor="regPassword">
                      Password
                    </label>
                    <input
                      id="regPassword"
                      type="password"
                      className="form-control"
                      value={authPassword}
                      onChange={(e) => setAuthPassword(e.target.value)}
                      required
                      autoComplete="new-password"
                    />
                  </div>
                  <div className="col-12 d-flex gap-2">
                    <button
                      className="btn btn-primary"
                      type="submit"
                      disabled={authBusy}
                    >
                      {authBusy
                        ? "Creating..."
                        : "Create Account &amp; Continue"}
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={() => setAuthStep("choose")}
                    >
                      Back
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        ) : null}

        {/* STEP 2: Registration Form (shown after auth) */}
        {authStep === "done" && (
          <>
            {(catError || subcatError || servicesError) && (
              <div className="alert alert-warning">
                {catError && <>Categories: {catError.message}. </>}
                {subcatError && <>Subcategories: {subcatError.message}. </>}
                {servicesError && <>Services: {servicesError.message}. </>}
              </div>
            )}

            {error && (
              <div className="alert alert-danger">
                {error.message || String(error)}
              </div>
            )}

            <form onSubmit={onSubmit}>
              {/* Basic Information */}
              <div className="card shadow-sm mb-3">
                <div className="card-body">
                  <h5 className="card-title">Basic Information</h5>
                  <div className="row g-3">
                    <div className="col-12 col-md-4">
                      <label className="form-label" htmlFor="firstName">
                        First Name *
                      </label>
                      <input
                        id="firstName"
                        name="firstName"
                        className="form-control"
                        value={form.firstName}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-12 col-md-4">
                      <label className="form-label" htmlFor="lastName">
                        Surname
                      </label>
                      <input
                        id="lastName"
                        name="lastName"
                        className="form-control"
                        value={form.lastName}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-12 col-md-4">
                      <label className="form-label" htmlFor="fatherName">
                        Father Name
                      </label>
                      <input
                        id="fatherName"
                        name="fatherName"
                        className="form-control"
                        value={form.fatherName}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-12 col-md-6">
                      <label className="form-label" htmlFor="mobile">
                        Mobile *
                      </label>
                      <input
                        id="mobile"
                        name="mobile"
                        className="form-control"
                        value={form.mobile}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-12 col-md-6">
                      <label className="form-label" htmlFor="email">
                        Email
                      </label>
                      <input
                        id="email"
                        name="email"
                        type="email"
                        className="form-control"
                        value={form.email}
                        onChange={handleChange}
                        placeholder="(Prefilled from your account if available)"
                      />
                    </div>

                    <div className="col-12">
                      <label className="form-label" htmlFor="address">
                        Address (Flat / Area / Landmark)
                      </label>
                      <textarea
                        id="address"
                        name="address"
                        className="form-control"
                        rows={2}
                        value={form.address}
                        onChange={handleChange}
                        placeholder="Flat / Area / Landmark"
                      />
                    </div>

                    {/* State / District / Mandal with ADD option */}
                    <div className="col-12 col-md-4">
                      <label className="form-label" htmlFor="state">
                        State *
                      </label>
                      <select
                        id="state"
                        name="state"
                        className="form-select"
                        value={form.state}
                        onChange={(e) => {
                          const newState = e.target.value;
                          setForm((f) => ({
                            ...f,
                            state: newState,
                            district: "",
                            mandal: "",
                          }));
                        }}
                        required
                      >
                        <option value="">(Select)</option>
                        {statesList.map((s) => (
                          <option key={s} value={s}>
                            {s}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12 col-md-4">
                      <label className="form-label" htmlFor="district">
                        District *
                      </label>
                      <select
                        id="district"
                        name="district"
                        className="form-select"
                        value={form.district}
                        onChange={(e) =>
                          setForm((f) => ({
                            ...f,
                            district: e.target.value,
                            mandal: "",
                          }))
                        }
                        disabled={!form.state}
                        required
                      >
                        {!form.state ? (
                          <option value="">— Select State first —</option>
                        ) : districtsForSelected.length === 0 ? (
                          <option value="">— No districts found —</option>
                        ) : (
                          <>
                            <option value="">(Select)</option>
                            {districtsForSelected.map((d) => (
                              <option key={d} value={d}>
                                {d}
                              </option>
                            ))}
                          </>
                        )}
                      </select>
                    </div>
                    <div className="col-12 col-md-4">
                      <label className="form-label" htmlFor="mandal">
                        Mandal (optional)
                      </label>
                      <select
                        id="mandal"
                        name="mandal"
                        className="form-select"
                        value={
                          mandalAddMode ? ADD_MANDAL_SENTINEL : form.mandal
                        }
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val === ADD_MANDAL_SENTINEL) {
                            setMandalAddMode(true);
                            setForm((f) => ({ ...f, mandal: "" }));
                          } else {
                            setMandalAddMode(false);
                            setForm((f) => ({ ...f, mandal: val }));
                          }
                        }}
                        disabled={!form.district}
                      >
                        {!form.district ? (
                          <option value="">— Select District first —</option>
                        ) : mandalsForSelected.length === 0 ? (
                          <>
                            <option value="">(None)</option>
                            <option value={ADD_MANDAL_SENTINEL}>
                              + Add mandal not listed…
                            </option>
                          </>
                        ) : (
                          <>
                            <option value="">(None)</option>
                            {mandalsForSelected.map((m) => (
                              <option key={m} value={m}>
                                {m}
                              </option>
                            ))}
                            <option value={ADD_MANDAL_SENTINEL}>
                              + Add mandal not listed…
                            </option>
                          </>
                        )}
                      </select>

                      {mandalAddMode && (
                        <div className="mt-2 d-flex gap-2">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter mandal name"
                            value={mandalInput}
                            onChange={(e) => setMandalInput(e.target.value)}
                          />
                          <button
                            type="button"
                            className="btn btn-outline-primary"
                            onClick={addCustomMandal}
                            disabled={!mandalInput.trim()}
                          >
                            Save
                          </button>
                          <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={() => {
                              setMandalAddMode(false);
                              setMandalInput("");
                            }}
                          >
                            Cancel
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Govt IDs */}
              <div className="card shadow-sm mb-3">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <div className="d-flex flex-row gap-3">
                      <h5 className="card-title ">Govt IDs</h5>
                      <small>
                        <label className="form-label mb-0">
                          (Authorized ID Photos 2)
                        </label>
                      </small>
                    </div>
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => addIdRow()}
                    >
                      + Add ID
                    </button>
                  </div>

                  {form.ids.map((row, i) => {
                    const available = availableIdTypesFor(i);
                    const selectedType = row.type;
                    const options =
                      selectedType && !available.includes(selectedType)
                        ? [selectedType, ...available]
                        : available;

                    return (
                      <div className="row g-2 align-items-end mb-2" key={i}>
                        <div className="col-12 col-md-3">
                          <label className="form-label">ID Type</label>
                          <select
                            className="form-select"
                            value={row.type}
                            onChange={(e) =>
                              handleIdChange(i, "type", e.target.value)
                            }
                          >
                            <option value="">(Select)</option>
                            {options.map((t) => (
                              <option key={`${i}-${t}`} value={t}>
                                {t}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-12 col-md-4">
                          <label className="form-label">ID Number</label>
                          <input
                            className="form-control"
                            value={row.value}
                            onChange={(e) =>
                              handleIdChange(i, "value", e.target.value)
                            }
                            placeholder="Enter ID number"
                          />
                        </div>
                        <div className="col-12 col-md-3">
                          <label className="form-label">Upload Photo</label>
                          <input
                            type="file"
                            accept="image/*"
                            capture="environment"
                            className="form-control"
                            onChange={(e) => {
                              const f = e.target.files?.[0];
                              if (!f) return;
                              setScanModal({
                                show: true,
                                title: "Scan Authorized ID",
                                target: "id",
                                idIndex: i,
                                file: f,
                                options: {
                                  maxWidth: 1600,
                                  maxHeight: 1600,
                                  maxBytes: 500 * 1024,
                                  mimeType: "image/jpeg",
                                  initialQuality: 0.85,
                                },
                              });
                            }}
                          />
                          {row.imageUrl && (
                            <div className="mt-1">
                              <a
                                href={row.imageUrl}
                                target="_blank"
                                rel="noreferrer"
                              >
                                View uploaded image
                              </a>
                            </div>
                          )}
                        </div>
                        <div className="col-12 col-md-2">
                          {form.ids.length > 2 && (
                            <button
                              type="button"
                              className="btn btn-outline-danger"
                              onClick={() => removeIdRow(i)}
                            >
                              Remove
                            </button>
                          )}
                        </div>
                      </div>
                    );
                  })}
                  <small className="text-muted">
                    Attach clear photos of at least two IDs. Each ID type can be
                    selected only once.
                  </small>
                </div>
              </div>

              {/* Profile Photo */}
              <div className="card shadow-sm mb-3">
                <div className="card-body">
                  <h5 className="card-title">Profile Photo</h5>
                  <input
                    type="file"
                    accept="image/*"
                    capture="environment"
                    className="form-control"
                    onChange={(e) => {
                      const f = e.target.files?.[0];
                      if (!f) return;
                      setScanModal({
                        show: true,
                        title: "Scan Profile Photo",
                        target: "pp",
                        idIndex: null,
                        file: f,
                        options: {
                          maxWidth: 1024,
                          maxHeight: 1024,
                          maxBytes: 300 * 1024,
                          mimeType: "image/jpeg",
                          initialQuality: 0.85,
                        },
                      });
                    }}
                  />
                  {form.profilePhotoUrl && (
                    <div className="mt-1">
                      <a
                        href={form.profilePhotoUrl}
                        target="_blank"
                        rel="noreferrer"
                      >
                        View photo
                      </a>
                    </div>
                  )}
                </div>
              </div>

              {/* Job Preferences (optional) — Single Picker + Selected List */}
              <div className="card shadow-sm mb-3">
                <div className="card-body">
                  <h5 className="card-title">Job Preferences (optional)</h5>

                  {/* Single Picker */}
                  <div className="row g-3 align-items-start">
                    <div className="col-12 col-md-7">
                      <label className="form-label">Search Job Title</label>
                      <input
                        className="form-control mb-2"
                        placeholder="Type to search e.g., Electrician, Plumber, Mason..."
                        value={titleQuery}
                        onChange={(e) => setTitleQuery(e.target.value)}
                      />

                      <label className="form-label">Job Title</label>
                      <select
                        className="form-select"
                        size={6}
                        value={pickerJobId}
                        onChange={(e) => setPickerJobId(e.target.value)}
                        disabled={allJobTitles.length === 0}
                      >
                        {allJobTitles.length === 0 ? (
                          <option value="">— No services configured —</option>
                        ) : filteredTitles.length === 0 ? (
                          <option value="">— No matches —</option>
                        ) : (
                          filteredTitles.map((t) => (
                            <option key={t.id} value={t.id}>
                              {t.label} — ({t.catLabel}
                              {t.subLabel ? ` › ${t.subLabel}` : ""})
                            </option>
                          ))
                        )}
                      </select>
                      <small className="text-muted">
                        Pick a title; Category &amp; Subcategory will show on
                        the right. Click “Add Job” to add it.
                      </small>
                    </div>

                    <div className="col-12 col-md-5">
                      <div className="border rounded p-2 bg-light">
                        <div className="mb-2">
                          <strong>Selected Title:</strong>{" "}
                          {pickerSelected ? pickerSelected.label : "—"}
                        </div>
                        <div className="mb-1">
                          <strong>Category:</strong>{" "}
                          {pickerSelected ? pickerSelected.catLabel : "—"}
                        </div>
                        <div className="mb-2">
                          <strong>Subcategory:</strong>{" "}
                          {pickerSelected ? pickerSelected.subLabel : "—"}
                        </div>
                        <button
                          type="button"
                          className="btn btn-outline-primary"
                          onClick={addSelectedJob}
                          disabled={
                            !pickerSelected ||
                            (form.jobs || []).length >= MAX_JOBS
                          }
                          title={
                            (form.jobs || []).length >= MAX_JOBS
                              ? `Maximum ${MAX_JOBS} jobs can be added`
                              : pickerSelected
                                ? "Add job"
                                : "Select a job title first"
                          }
                        >
                          + Add Job
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Selected Jobs List */}
                  <div className="mt-3">
                    <label className="form-label">Selected Jobs</label>
                    {(form.jobs || []).length === 0 ? (
                      <div className="text-muted">No jobs added yet.</div>
                    ) : (
                      <div className="d-flex flex-column gap-2">
                        {form.jobs.map((j, i) => {
                          const id = `${j.categoryKey}__${j.subcategoryKey}__${j.title}`;
                          const highlight =
                            lastAddedJobId && lastAddedJobId === id
                              ? "border-success bg-success-subtle"
                              : "";
                          return (
                            <div
                              key={`sel-job-${i}`}
                              className={`border rounded p-2 ${highlight}`}
                            >
                              <div className="row g-2 align-items-center">
                                <div className="col-12 col-md-6">
                                  <div className="fw-semibold">{j.title}</div>
                                  <div className="text-muted small">
                                    {catLabelByKey.get(j.categoryKey) ||
                                      j.categoryKey}
                                    {j.subcategoryKey
                                      ? ` › ${subLabelByKey.get(j.subcategoryKey) || j.subcategoryKey}`
                                      : ""}
                                  </div>
                                </div>
                                <div className="col-6 col-md-3">
                                  <label className="form-label mb-1">
                                    Experience (years)
                                  </label>
                                  <input
                                    className="form-control"
                                    type="number"
                                    min="0"
                                    value={j.experienceYears || ""}
                                    onChange={(e) =>
                                      handleJobExperienceChange(
                                        i,
                                        e.target.value,
                                      )
                                    }
                                  />
                                </div>
                                <div className="col-6 col-md-3 d-flex justify-content-end">
                                  <button
                                    type="button"
                                    className="btn btn-outline-danger"
                                    onClick={() => removeJob(i)}
                                  >
                                    Remove
                                  </button>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                    <div className="form-text">
                      You can add up to {MAX_JOBS} jobs. Avoid duplicates.
                    </div>
                  </div>

                  {/* Availability & Bio */}
                  <div className="row g-2 mt-3">
                    <div className="col-12 col-md-3">
                      <label className="form-label">Availability</label>
                      <select
                        className="form-select"
                        name="availability"
                        value={form.availability}
                        onChange={handleChange}
                      >
                        <option value="full-time">Full-time</option>
                        <option value="part-time">Part-time</option>
                        <option value="contract">Contract</option>
                        <option value="on-call">On-call</option>
                      </select>
                    </div>

                    <div className="col-12">
                      <label className="form-label">
                        About you (short bio)
                      </label>
                      <textarea
                        className="form-control"
                        rows={3}
                        name="bio"
                        value={form.bio}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Submit */}
              <div className="d-flex gap-2">
                <button
                  className="btn btn-primary"
                  type="submit"
                  disabled={busy}
                >
                  {busy ? "Submitting..." : "Submit Registration"}
                </button>
                <a className="btn btn-outline-secondary" href="/">
                  Cancel
                </a>
              </div>
            </form>
          </>
        )}
      </div>

      {/* Scan/Compress/Upload modal */}
      <DocumentScanModal
        show={scanModal.show}
        file={scanModal.file}
        title={scanModal.title}
        options={scanModal.options}
        onCancel={() => setScanModal((s) => ({ ...s, show: false }))}
        onConfirm={async (compressedBlob) => {
          try {
            await ensureSignedIn(); // anonymous auth
            const mobileSafe = String(form.mobile || "public").replace(
              /[^\w.-]/g,
              "_",
            );

            if (scanModal.target === "id") {
              const fileName = `id-${scanModal.idIndex + 1}.jpg`;
              const { url } = await uploadToStorage(
                compressedBlob,
                `public/${mobileSafe}/ids`,
                fileName,
              );
              setForm((prev) => {
                const ids = [...(prev.ids || [])];
                if (
                  typeof scanModal.idIndex === "number" &&
                  ids[scanModal.idIndex]
                ) {
                  ids[scanModal.idIndex] = {
                    ...ids[scanModal.idIndex],
                    imageUrl: url,
                  };
                }
                return { ...prev, ids };
              });
            } else if (scanModal.target === "pp") {
              const { url } = await uploadToStorage(
                compressedBlob,
                `public/${mobileSafe}/profile`,
                `profile.jpg`,
              );
              setForm((f) => ({ ...f, profilePhotoUrl: url }));
            }
          } catch (e) {
            console.error(e);
            setError(e);
          } finally {
            setScanModal((s) => ({ ...s, show: false }));
          }
        }}
      />
    </section>
  );
}
